import templateUrl from './home-banner-list.html';
import publishTemplateUrl from './home-banner-publish-template.html';
import unpublishTemplateUrl from './home-banner-unpublish-template.html';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';

export const homeBannerListComponent = {
	templateUrl,

	bindings: {
		details: '<',
		slugUrl: '@'
	},

	controller: class HomeBannerListComponent {
		constructor($state, toastr, ApiService, ModalService, HomeBannerService, DynamicMenusService, SlugService) {
			'ngInject';

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.homeBannerService = HomeBannerService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		$onInit() {
			this.details = this.homeBannerService.getBannerList(this.details);
			this.step = 1;
			this.tabTemplateUrl = publishTemplateUrl;
			this.isPublishedClicked = true;
		}

		routeSequencePageUrl() {
			const url = this.slugService.getSequencePageURL(this.slugUrl);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		routeAddPageUrl() {
			const url = this.slugService.getAddPageURL(this.slugUrl);

			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}

		tabChange(status) {
			if (status === 'publish') {
				this.tabTemplateUrl = publishTemplateUrl;
				this.isPublishedClicked = true;
			} else {
				this.tabTemplateUrl = unpublishTemplateUrl;
				this.isPublishedClicked = false;
			}
		}

		routeEditPageUrl(slug) {
			const url = this.slugService.getEditPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}

		//on delete the banner
		onDelete(slug) {
			this.modalService.open({
				details: {
					bodyMessage: 'Are you sure you want to delete the banner?'
				},

				buttons: [
					{
						name: 'No'
					},
					{
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}
				]
			});

			function onSubmit() {
				let publishedIndex = '';
				let unpublishedIndex = '';
				this.dynamicMenusService.deleteMenuDetailsByUrl(`${slug}/delete`)
					.then(({data}) => {
						let publishedIndex = findIndex(this.details.publishedList, ['slug', slug]);
						if (publishedIndex !== -1) {
							this.details.publishedList = this.details.publishedList.filter(detail => detail.slug !== slug);
						} else {
							this.details.unPublishedList = this.details.unPublishedList.filter(detail => detail.slug !== slug);
						}
						this.toastr.success("Banner Deleted successfully");
						this.$state.go('app.dashboard.HomeBanner');
					}).catch((err) => {
						this.toastr.error(err);
					});
			}
		}

		//to publish or unpublish the banner
		publishUnpublishBanner(id, isActive) {
			let publishedIndex = '';
			let unpublishedIndex = '';
			this.homeBannerService.publishUnpublishBanner(id, isActive).then((response) => {
				if (isActive) {
					let publishedItem = find(this.details.publishedList, ['id', id]);
					publishedItem.isActive = false;
					this.details.publishedList = this.details.publishedList.filter(detail => detail.id !== id);
					this.details.unPublishedList.push(publishedItem);
					this.tabTemplateUrl = unpublishTemplateUrl;
					this.isPublishedClicked = false;
					this.toastr.success("Banner Unublished Successfully");
				} else {
					let unpublishedItem = find(this.details.unPublishedList, ['id', id]);
					unpublishedItem.isActive = true;
					this.details.unPublishedList = this.details.unPublishedList.filter(detail => detail.id !== id);
					this.details.publishedList.push(unpublishedItem);
					this.tabTemplateUrl = publishTemplateUrl;
					this.isPublishedClicked = true;
					this.toastr.success("Banner Published Successfully");
				}
				this.$state.go('app.dashboard.HomeBanner');
			}).catch((err) => {
				this.toastr.error(err);
			});
		}

		_getImage(detail) {
			const image = detail.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/home-banner/home-banner-list/home-banner-list.component.js